
import React, { useRef, useEffect, useState } from 'react'

import '../styleCss/a.css'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';
import TypingText from './TypingText';
import SEO from '../SEO';
import Footer from './Footer';
import Header from './Header';

const Referral = () => {

  const [showContactInfo, setShowContactInfo] = useState();
  useEffect(() => {
    window.scrollTo(0, 0); // scrolls to top when component mounts
  }, []);

  useEffect(() => {
    const navbar = document.getElementById("navbar");

    const media = window.matchMedia("(width <= 1024px)");

    function updateNavbar(e) {
      const isMobile = e.matches;
      const menu_div = document.getElementById("mob_menu");
      if (isMobile) {
        menu_div.style.display = "block";
        navbar.setAttribute("inert", "");
      } else {
        menu_div.style.display = "none";
        navbar.removeAttribute("inert");
      }
    }

    media.addEventListener("change", updateNavbar);
    updateNavbar(media);

    return () => media.removeEventListener("change", updateNavbar);
  }, []);




  const openSidebar = () => {
    const openButton = document.getElementById("open-sidebar-button");
    const navbar = document.getElementById("navbar");


    navbar.classList.add("show");
    openButton.setAttribute("aria-expanded", "true");
    openButton.style.display = "none";
    navbar.removeAttribute("inert");
  };

  const closeSidebar = () => {
    const openButton = document.getElementById("open-sidebar-button");
    const navbar = document.getElementById("navbar");

    if (openButton.getAttribute('aria-expanded') === 'true') {


      navbar.classList.remove('show');
      openButton.setAttribute('aria-expanded', 'false');
      openButton.setAttribute('style', 'display: block;');
      navbar.setAttribute('inert', '');

    }
  };





  return (

    <div className='w-screen h-full'>

      <Header></Header>

    

      <div id="overlay" aria-hidden="true"></div>


      <div className="tchead">
        <div className="tcinhead">
          <div style={{ textAlign: "center" }}>
            <h1>
            <b>
              Referral Terms & Conditions</b>
              </h1>
              <br /><br />
          </div>

          (I) Eligibility
          <br />
          &nbsp;&nbsp;&nbsp; * Only registered users of AlgoController.com are eligible to participate in the referral program.
          <br />
          &nbsp;&nbsp;&nbsp; * Referral rewards are only applicable when the referred user signs up using your unique referral link and completes the required action (e.g., subscription or purchase).
          <br /><br />
          (II) Referral Reward Structure
          <br />
          &nbsp;&nbsp;&nbsp; * Referral rewards may be offered in the form of cashback, discounts, or free subscription days.
          <br />
          &nbsp;&nbsp;&nbsp; * Reward values and conditions are subject to change and will be displayed on the referral dashboard.
          <br /><br />
          (III) Valid Referrals
          <br />
          A referral is considered valid only if the referred person:
          <br />
          &nbsp;&nbsp;&nbsp; * Has not previously registered on AlgoController.com.
          <br />
          &nbsp;&nbsp;&nbsp; * Signs up using your referral link.
          <br />
          &nbsp;&nbsp;&nbsp; * Completes any qualifying criteria (e.g., paid subscription, KYC verification).
          <br /><br />
          (IV) Reward Payout
          <br />
          &nbsp;&nbsp;&nbsp; * Rewards will be credited to your Bank account within 7–14 business days after the referred user completes the qualifying criteria.
          <br />
          &nbsp;&nbsp;&nbsp; * Payouts may be paused in case of suspicious activity or pending account verifications.
          <br /><br />
          (V) Prohibited Conduct
          <br />
          You may not:
          <br />
          &nbsp;&nbsp;&nbsp; * Use referral links in spam emails, paid ads, or on coupon sites.
          <br />
          &nbsp;&nbsp;&nbsp; * Mislead or deceive others to get them to sign up.
          <br />
          &nbsp;&nbsp;&nbsp; * Refer yourself or create multiple fake accounts.
          <br /><br />
          (VI) Termination & Modification
          <br />
          AlgoController.com reserves the right to:
          <br />
          &nbsp;&nbsp;&nbsp; * Modify or cancel the referral program at any time without prior notice.
          <br />
          &nbsp;&nbsp;&nbsp; * Revoke referral rewards in case of suspected fraud or abuse.
          <br /><br />
          (VII) Tax Implications
          <br />
          &nbsp;&nbsp;&nbsp; * If required by Indian law, you are responsible for declaring and paying any taxes related to your referral earnings.
          <br /><br />
          (VIII) Dispute Resolution
          <br />
          &nbsp;&nbsp;&nbsp; * AlgoController.com decision regarding referrals and rewards shall be final and binding.
          <br /><br />
          For any disputes or questions, contact: <b>support@algocontroller.com</b>


          <br /><br />
        </div>
      </div>

      <br></br>


      <div id="myModal" className="modal">
        <div className="modal-content">
          <span className="close" >&times;</span>
          <h2>Hello!</h2>
          <p><b>We’re working hard behind the scenes to bring something great!</b><br />
            Some features and links will be available soon.<br />
            Thank you for your patience — our website is currently under construction.</p>
        </div>
      </div>

      <br /><br />
    <Footer></Footer>

    </div>
  )

}

export default Referral